var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_167859333119484963597983105152960596523",
    d: "M24.585 21.073c1.509 0 2.732 1.223 2.732 2.732 0 1.509-1.223 2.732-2.732 2.732h-14.22c-1.51 0-2.732-1.223-2.732-2.732 0-1.509 1.223-2.732 2.731-2.732h14.221zm0-10.536c1.509 0 2.732 1.223 2.732 2.731 0 1.509-1.223 2.732-2.732 2.732H2.732C1.223 16 0 14.777 0 13.268c0-1.508 1.223-2.731 2.732-2.731h21.853zm0-10.537c1.509 0 2.732 1.223 2.732 2.732 0 1.508-1.223 2.731-2.732 2.731H2.732C1.223 5.463 0 4.24 0 2.732 0 1.223 1.223 0 2.732 0h21.853z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hinava_random_uuid_21723274505599381366724467645681259105",
    d: "M-2.763 -3.152H29.696000000000005V30.469H-2.763z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_48876212871591582963744760188990517269",
    x1: "50%",
    x2: "50%",
    y1: "32.846%",
    y2: "90.794%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00FFA9"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-264 -270) translate(248 262) translate(16 8) translate(2.341 2.732)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_211219012603112546291289275453805486747",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hinava_random_uuid_167859333119484963597983105152960596523"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#hinava_random_uuid_167859333119484963597983105152960596523"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_211219012603112546291289275453805486747)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#hinava_random_uuid_21723274505599381366724467645681259105"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hinava_random_uuid_48876212871591582963744760188990517269)",
    xlinkHref: "#hinava_random_uuid_21723274505599381366724467645681259105"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.eeeb0c8fd07d9c618b97a1ca8acde61d.svg";
export { ForwardRef as ReactComponent };